import React from "react";
import { Link } from "react-scroll";
import { ArrowRight } from "lucide-react";

const Hero = () => {
  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center pt-20 overflow-hidden bg-primary"
    >
      {/* Background Overlay/Image */}
      <div className="absolute inset-0 z-0 opacity-20">
        <div className="absolute inset-0 bg-gradient-to-r from-primary to-transparent z-10"></div>
        {/* Placeholder for abstract finance background */}
        <div className="w-full h-full bg-cover bg-center">
          <img
            src="/background.jpg"
            alt=""
            role="presentation"
            className="w-full h-full object-cover"
          />
        </div>
      </div>

      <div className="container mx-auto px-12 relative z-10 flex flex-col md:flex-row items-center py-12 md:py-0">
        <div className="md:w-1/2 text-white">
          <div className="inline-block bg-slate-800/50 backdrop-blur-sm px-4 py-1 rounded-full border border-slate-700 mb-6">
            <span className="text-white font-semibold text-sm tracking-wider uppercase">
              Audit Firm
            </span>
          </div>
          <h1 className="text-5xl md:text-6xl font-bold leading-tight mb-6">
            Audit. Advisory <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-white to-white/50">
              Assurance.
            </span>
          </h1>
          <p className="text-slate-300 text-lg md:text-xl mb-8 leading-relaxed max-w-lg">
            Alpha Audit & Advisory is a trusted audit firm delivering accurate
            financial insights and reliable compliance solutions.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <Link
              to="contact"
              smooth={true}
              duration={500}
              className="bg-secondary text-white hover:bg-white hover:text-primary  px-8 py-4 rounded-lg font-bold text-lg transition-all flex items-center justify-center gap-2 cursor-pointer"
            >
              Consult Now <ArrowRight size={20} />
            </Link>
            <Link
              to="services"
              smooth={true}
              duration={500}
              className="bg-transparent border border-white hover:bg-slate-800 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-all text-center cursor-pointer"
            >
              Explore Services
            </Link>
          </div>
        </div>

        {/* Abstract Visual/Illustration on the right (optional) */}
        <div className="md:w-1/2 mt-12 md:mt-0 relative hidden md:block">
          <div className="relative w-full max-w-lg mx-auto aspect-square bg-gradient-to-tr from-secondary/20 to-primary rounded-full blur-3xl opacity-30 animate-pulse"></div>
          {/* Could place a dashboard mockup or 3D element here */}
        </div>
      </div>
    </section>
  );
};

export default Hero;
